import axios from 'axios'
import { clone, getCurrentPosition } from '@/util/libUtil.js'
import { getFirstLastDayOfMonth, formatDateYYYYMMDD, blobPDF } from '@/util/libUtil.js';

const state = {
    isLoading: false,
    dateFilter: new Date(),
    commercial: null,
    punches: [],
    paths: {
        punchInPath: '/api/cuentas/punch-in/',
        punchNowPath: '/api/cuentas/punch-in-now/',
        getHtmlPunchesPath: '/api/cuentas/generate-punches-html',
        getPdfPunchesPath: '/api/cuentas/generate-punches-pdf',
    }
}

const mutations = {
    isLoading(state, isLoading) {
        state.isLoading = isLoading
    },
    dateFilter(state, dateFilter) {
        state.dateFilter = dateFilter
    },
    punches(state, punches) {
        state.punches = clone(punches)
    },
    commercial(state, commercial) {
        state.commercial = clone(commercial)
    }
}

const actions = {
    async fetchHtmlPunches({ commit, getters, dispatch, rootState, rootGetters }) {
        commit('isLoading', true)
        try{
            const date = formatDateYYYYMMDD(state.dateFilter)
            const commercial = rootGetters['storage/getAccountParam'](state.commercial);
            const response = await axios.get(getters.getEndpointFromPath(`${state.paths.getHtmlPunchesPath}/${date}/${commercial}`))
            rootState.util.PDFView.ofertaHtml = response.data
        } catch(err) {
            dispatch('util/showStatusSnackBar', {
                error: err,
                statusType: 'error',
                message: 'Error al descargar el reporte',
            }, { root: true })
        }
        commit('isLoading', false)
    },
    async fetchPdfPunches({ commit, getters, dispatch, rootState, rootGetters }) {
        commit('isLoading', true)
        try{
            const date = formatDateYYYYMMDD(state.dateFilter)
            const commercial = rootGetters['storage/getAccountParam'](state.commercial);
            const response = await axios.get(getters.getEndpointFromPath(
                `${state.paths.getPdfPunchesPath}/${date}/${commercial}`),
                { responseType: "blob" }
            )
            rootState.util.PDFView.ofertaPdf = response.data

            blobPDF(response, '')
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al descargar el reporte',
            }, { root: true })
        }
        commit('isLoading', false)
    },
    async fetchPunches({ commit, getters, rootGetters }) {
        commit('isLoading', true)
        const commercial = rootGetters['storage/getAccountParam'](state.commercial);
        const response = await axios.get(getters.getEndpointFromPath(state.paths.punchInPath), {
            params: {
                commercial: commercial,
                date: getFirstLastDayOfMonth(state.dateFilter).map((item)=> String(formatDateYYYYMMDD(item)))
            }
        })
        commit('punches', response.data)
        commit('isLoading', false)
    },
    async savePunchIn({ getters, state, dispatch, commit }, form) {
        try {
            commit('isLoading', true)
            const pos = await getCurrentPosition()
            for (const key in form.punches) {
                const timeIn = form.punches[key].IN
                const timeOut = form.punches[key].OUT

                form.punches[key].IN = {}
                form.punches[key].IN['time'] = timeIn
                form.punches[key].IN['location'] = pos
                
                form.punches[key].OUT = {}
                form.punches[key].OUT['time'] = timeOut
                form.punches[key].OUT['location'] = pos

            }
            await axios.post(getters.getEndpointFromPath(state.paths.punchInPath), form)
            dispatch('login/getCheckinvalidPunchIn', null, { root: true })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Fichaje Registrado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Registrar el Fichaje',
            }, { root: true })
        }

        dispatch('fetchPunches')
        commit('isLoading', false)
    },
    async savePunchNow({ getters, state, dispatch, commit }) {
        try {
            if(!state.isLoading){
                commit('isLoading', true)
                const pos = await getCurrentPosition()
                await axios.post(getters.getEndpointFromPath(state.paths.punchNowPath), {
                    commercial: state.commercial,
                    location: pos
                })
                dispatch('util/showStatusSnackBar', {
                    statusType: 'success',
                    message: "Fichaje Registrado!",
                }, { root: true })
            }

        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Registrar el Fichaje',
            }, { root: true })
        }

        dispatch('fetchPunches')
        commit('isLoading', false)
    },
    async editPunchIn({ getters, state, dispatch, commit }, form) {
        try {
            commit('isLoading', true)
            const pos = await getCurrentPosition()
            for (const key in form.punches) {
                const timeIn = form.punches[key].IN
                const timeOut = form.punches[key].OUT

                if (typeof(timeIn) === 'string') {
                    form.punches[key].IN = {}
                    form.punches[key].IN['time'] = timeIn
                    form.punches[key].IN['location'] = pos
                }

                if (typeof(timeOut) === 'string') {
                    form.punches[key].OUT = {}
                    form.punches[key].OUT['time'] = timeOut
                    form.punches[key].OUT['location'] = pos
                }
            }
            await axios.put(`${getters.getEndpointFromPath(state.paths.punchInPath)}${form.id}/`, form)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Fichaje Actualizado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Actualizar el Fichaje',
            }, { root: true })
        }

        dispatch('fetchPunches')
        commit('isLoading', false)
    },
    async deletePunchIn({ getters, state, dispatch, commit }, id) {
        try {
            commit('isLoading', true)
            let resp = await axios.delete(`${getters.getEndpointFromPath(state.paths.punchInPath)}${id}/`)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Fichaje Borrado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Borrar el Fichaje',
            }, { root: true })
        }
        
        dispatch('fetchPunches')
        commit('isLoading', false)
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
